import { createFileRoute } from '@tanstack/react-router'
import { CustomersListPage } from '../../../features/customers/customers-list-page'
import { customerSearchSchema } from '../../../features/customers/search'

export const Route = createFileRoute('/_app/customers/')({
  validateSearch: customerSearchSchema,
  component: CustomersListPage,
})
